<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header
    v-if="!headerBarFixed"
    :class="[
      fixedHeader && 'ant-header-fixedHeader',
      sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed'
    ]"
    :style="{ padding: '0' }"
  >
    <div v-if="mode === 'sidemenu'" class="header" :class="theme && device === 'desktop' ? 'p30' : ''">
      <div class="flex-center" v-if="device === 'mobile'">
        <a-icon class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle"></a-icon>
        <!-- <span>上海设序科技有限公司</span> -->
      </div>
      <!-- <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggle" /> -->

      <span class="left">
        <img class="logo" v-if="device === 'desktop'" src="~@/assets/logo1.png" alt="logo" />
        <div class="app-name">
          <div class="cur-app" @click.stop="showApps = !showApps">
            {{ curApp }}
            <a-icon type="down"></a-icon>
          </div>
          <div class="app-permission" v-show="showApps">
            <div class="personal" v-if="apps.length > 0">
              <span class="title">个人</span>
              <ul>
                <li v-for="item in apps" :key="item.appId" @click="_goApp(item)">
                  <img :src="item.logo" class="icon-bg" alt="" />
                  <span>{{ item.name }}</span>
                  <span v-if="item.isDefault" class="iconfont ok icon-duihao"></span>
                </li>
              </ul>
            </div>
            <div class="company" v-if="tenants.length > 0">
              <span class="title">企业</span>
              <ul>
                <li v-for="item in tenants" :key="item.id">
                  <span>{{ item.name }}</span>
                  <img class="next" src="@/assets/workbench/next.png" alt="" />
                  <ul class="two" v-if="item.apps.length > 0">
                    <li v-for="a in item.apps" :key="a.id" @click="_goApp(item, true, a)">
                      <img :src="a.logo" class="icon-bg" alt="" />
                      <span>{{ a.name }}</span>
                      <span v-if="a.isDefault" class="iconfont ok icon-duihao"></span>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </span>
      <div class="right">
        <Client />
        <UserInfo ref="userInfo" />
        <!-- <span class="action">
          <a class="logout_title" href="javascript:;" @click="handleLogout">
            <a-icon type="logout" />
            <span v-if="device === 'desktop'">&nbsp;退出登录</span>
          </a>
        </span> -->
      </div>

      <!-- <user-menu :theme="theme" /> -->
    </div>
    <!-- 顶部导航栏模式 -->
    <!-- <div v-else :class="['top-nav-header-index', theme]">
      <div class="header-index-wide">
        <div class="header-index-left" :style="topMenuStyle.headerIndexLeft">
          <logo class="top-nav-header" :show-title="device !== 'mobile'" :style="topMenuStyle.topNavHeader" />
          <div v-if="device !== 'mobile'" :style="topMenuStyle.topSmenuStyle">
            <s-menu mode="horizontal" :menu="menus" :theme="theme" @updateMenuTitle="handleUpdateMenuTitle"></s-menu>
          </div>
          <a-icon v-else class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle"></a-icon>
        </div>
        <user-menu class="header-index-right" :theme="theme" :style="topMenuStyle.headerIndexRight" />
      </div>
    </div> -->
  </a-layout-header>
</template>

<script>
import UserMenu from '../tools/UserMenu'
import SMenu from '../menu/'
import Logo from '../tools/Logo'
import { mixin } from '@/utils/mixin.js'
import { mapState, mapActions, mapMutations } from 'vuex'
import UserInfo from '@/components/user'
import Client from '@/components/client'
import store from '@/store'
import router from '@/router'
import { generateIndexRouter } from '@/utils/util'
import { getUrlValues } from '@/utils/qs'
import { TENANT_ID } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  name: 'GlobalHeader',
  components: {
    UserMenu,
    SMenu,
    Logo,
    UserInfo,
    Client
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    }
  },
  computed: {
    ...mapState(['user'])
  },
  data() {
    return {
      showApps: false,
      headerBarFixed: false,
      // update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
      topMenuStyle: {
        headerIndexLeft: {},
        topNavHeader: {},
        headerIndexRight: {},
        topSmenuStyle: {}
      },
      curApp: '',
      chatStatus: '',
      apps: [],
      tenants: []
    }
  },
  watch: {
    /** 监听设备变化 */
    device() {
      if (this.mode === 'topmenu') {
        this.buildTopMenuStyle()
      }
    },
    /** 监听导航栏模式变化 */
    mode(newVal) {
      if (newVal === 'topmenu') {
        this.buildTopMenuStyle()
      }
    },
    $route() {
      this._getAppsList()
    }
  },
  created() {
    this.apps = this.user.apps
    this.tenants = this.user.tenants
    const { app } = getUrlValues()
    if (this.apps.length !== 0) {
      // 个人版有
      if (app) {
        if (this.apps.findIndex(item => item.appCode === app) !== -1) {
          this._goApp(this.apps.find(item => item.appCode === app))
        } else if (this.tenants.length > 0) {
          this.tenants.forEach(item => {
            for (let a of item.apps) {
              if (a.appCode === app) {
                this._goApp(item, true, a)
                return
              }
            }
          })
        }
      }
    } else {
      if (this.tenants.length > 0) {
        if (app) {
          this.tenants.forEach(item => {
            for (let a of item.apps) {
              if (a.appCode === app) {
                this._goApp(item, true, a)
                return
              }
            }
          })
        }
      }
    }
    this._getAppsList()
  },
  // update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    // update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    if (this.mode === 'topmenu') {
      this.buildTopMenuStyle()
    }
    // update-end--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
  },
  methods: {
    ...mapActions(['Logout']),
    ...mapMutations(['SET_TENANT']),
    async _getAppsList() {
      const { path } = this.$route
      this.apps = this.user.apps
      this.tenants = this.user.tenants
      const appCode = sessionStorage.getItem('appCode')
      if (this.apps.length !== 0) {
        this.apps = this.apps.map(item => ({ ...item, isDefault: false }))
        // 个人版有
        if (this.tenants.length > 0) {
          // 企业版也有
          this.tenants.forEach(tenant => {
            if (tenant.apps && tenant.apps.length > 0) {
              tenant.apps = tenant.apps.map(app => ({ ...app, isDefault: false }))
            }
          })
        }
        if (appCode) {
          if (appCode.includes('/')) {
            const id = appCode.split('/')[0]
            let tenant = this.tenants.find(item => item.id === id)
            let app = tenant.apps.find(item => item.appCode === appCode.split('/')[1])
            app.isDefault = true
            this.curApp = `${tenant.name}-${app.name}`
          } else {
            this.curApp = this.apps.find(item => appCode === item.appCode).name
            this.apps = this.apps.map(item => ({ ...item, isDefault: appCode ? item.appCode === appCode : true }))
          }
        } else {
          const i = this.apps.findIndex(item => item.url === this.$route.fullPath)
          sessionStorage.setItem('appCode', this.apps[i].appCode)
          this.apps[i].isDefault = true
          this.curApp = this.apps[i].name
        }
      } else {
        // 个人版没有
        if (this.tenants.length > 0) {
          // 企业版有
          this.tenants.forEach(tenant => {
            if (tenant.apps && tenant.apps.length > 0) {
              tenant.apps = tenant.apps.map(app => ({ ...app, isDefault: false }))
            }
          })
          if (appCode) {
            const id = appCode.split('/')[0]
            let tenant = this.tenants.find(item => item.id === id)
            let app = tenant.apps.find(item => item.appCode === appCode.split('/')[1])
            app.isDefault = true
            this.curApp = `${tenant.name}-${app.name}`
          } else {
            sessionStorage.setItem('appCode', this.tenants[0].apps[0].appCode)
            this.tenants[0].apps[0].isDefault = true
            this.curApp = `${this.tenants[0].name}-${this.tenants[0].apps[0].name}`
          }
        }
      }
    },
    async _goApp(item, flag, i) {
      if (this.curApp === item.name) {
        return
      }
      this.tenants.forEach(tenant => {
        tenant.apps = tenant.apps.map(app => ({ ...app, isDefault: false }))
      })
      if (!flag) {
        // 表示个人版app
        sessionStorage.setItem('appCode', item.appCode)
        this.curApp = item.name
        this.apps = this.apps.map(item => ({ ...item, isDefault: item.name === this.curApp }))
        Vue.ls.set(TENANT_ID, 0, 7 * 24 * 60 * 60 * 1000)
        this.SET_TENANT(null)
        this.$router.replace({ name: 'goApp', params: { app: item } })
      } else {
        // 表示企业版app
        sessionStorage.setItem('appCode', `${item.id}/${i.appCode}`)
        this.curApp = `${item.name}-${i.name}`
        this.apps = this.apps.map(item => ({ ...item, isDefault: false }))
        item.apps = item.apps.map(app => ({ ...app, isDefault: app.name === this.curApp }))
        Vue.ls.set(TENANT_ID, item.id, 7 * 24 * 60 * 60 * 1000)
        this.SET_TENANT(item.id)
        this.$router.replace({ name: 'goApp', params: { app: i, tenant: item } })
      }
    },
    handleScroll() {
      if (this.autoHideHeader) {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 100) {
          this.headerBarFixed = true
        } else {
          this.headerBarFixed = false
        }
      } else {
        this.headerBarFixed = false
      }
    },
    handleLogout() {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              // update-begin author:wangshuai date:20200601 for: 退出登录跳转登录页面
              // that.$router.push({ path: '/user/login' })
              // window.location.reload()
              // update-end author:wangshuai date:20200601 for: 退出登录跳转登录页面
            })
            .catch(err => {
              that.$message.error({
                title: '错误',
                description: err.message
              })
            })
        },
        onCancel() {}
      })
    },
    toggle() {
      this.$emit('toggle')
    },
    // update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----
    buildTopMenuStyle() {
      if (this.mode === 'topmenu') {
        if (this.device === 'mobile') {
          // 手机端需要清空样式，否则显示会错乱
          this.topMenuStyle.topNavHeader = {}
          this.topMenuStyle.topSmenuStyle = {}
          this.topMenuStyle.headerIndexRight = {}
          this.topMenuStyle.headerIndexLeft = {}
        } else {
          let rightWidth = '360px'
          this.topMenuStyle.topNavHeader = { 'min-width': '165px' }
          this.topMenuStyle.topSmenuStyle = { width: 'calc(100% - 165px)' }
          this.topMenuStyle.headerIndexRight = { 'min-width': rightWidth }
          this.topMenuStyle.headerIndexLeft = { width: `calc(100% - ${rightWidth})` }
        }
      }
    },
    // update-begin--author:sunjianlei---date:20190508------for: 顶部导航栏过长时显示更多按钮-----

    // update-begin-author:sunjianlei date:20210508 for: 修复动态功能测试菜单、带参数菜单标题错误、展开错误的问题
    handleUpdateMenuTitle(value) {
      this.$emit('updateMenuTitle', value)
    }
    // update-end-author:sunjianlei date:20210508 for: 修复动态功能测试菜单、带参数菜单标题错误、展开错误的问题
  }
}
</script>

<style lang="less" scoped>
/* update_begin author:scott date:20190220 for: 缩小首页布局顶部的高度*/

@height: 59px;

.layout {
  .top-nav-header-index {
    .header-index-wide {
      margin-left: 10px;

      .ant-menu.ant-menu-horizontal {
        height: @height;
        line-height: @height;
      }
    }
    .trigger {
      line-height: 64px;
      &:hover {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .p30 {
    padding: 0 30px;
  }

  .header {
    z-index: 2;
    color: white;
    height: @height;
    background-color: #fff;
    transition: background 300ms;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .flex-center {
      display: flex;
      align-items: center;
    }

    i {
      color: #0593e9;
      padding: 0 10px;
    }

    span {
      font-size: 12px;
      color: #333;
    }

    .logo {
      height: 26px;
      margin-right: 20px;
    }

    .left {
      display: flex;
      align-items: center;
      .app-name {
        color: #3a3f63;
        font-weight: 500;
        font-size: 20px;
        position: relative;
        .cur-app {
          cursor: pointer;
        }
        i {
          font-size: 12px;
        }
        .app-permission {
          width: 260px;
          position: absolute;
          top: 50px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #fff;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
          border-radius: 8px;
          padding: 0 16px;
          margin: 0;
          .title {
            font-size: 12px;
            color: #9599af;
            margin-bottom: 12px;
          }
          ul {
            margin: 0;
            padding: 0;
            li {
              list-style: none;
              display: flex;
              align-items: center;
              position: relative;
              cursor: pointer;
              padding: 0 4px;
              border-radius: 6px;
              &:hover {
                background-color: #f3f4f8;
              }
              &:hover .two {
                display: block;
              }
              .ok {
                position: absolute;
                right: 0;
                color: #858ebd;
                font-size: 16px;
              }
              .next {
                position: absolute;
                right: 0;
              }
              span {
                font-size: 14px;
                height: 36px;
                line-height: 36px;
              }
              .icon-bg {
                width: 28px;
                height: 28px;
                border-radius: 6px;
                text-align: center;
                margin-right: 8px;
                line-height: 25px;
              }
            }
          }
          .personal {
            line-height: 36px;
            border-bottom: 1px solid #efefef;
            padding-bottom: 10px;
          }
          .company {
            line-height: 36px;
            padding-bottom: 10px;
            .two {
              display: none;
              background-color: #fff;
              position: absolute;
              right: -185px;
              top: 0;
              box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
              border-radius: 8px;
              width: 190px;
              padding: 8px;
            }
          }
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
    }

    .action {
      span {
        color: #5a607f;
      }
    }

    /* dark 样式 */
    &.dark {
      color: #000000;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
      background-color: white !important;
    }
  }

  .header,
  .top-nav-header-index {
    &.dark .trigger:hover {
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.ant-layout-header {
  height: @height;
  line-height: @height;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

/* update_end author:scott date:20190220 for: 缩小首页布局顶部的高度*/
</style>
